import { render } from "./RespMenu.vue?vue&type=template&id=299a813a&scoped=true&ts=true"
import script from "./RespMenu.vue?vue&type=script&lang=ts"
export * from "./RespMenu.vue?vue&type=script&lang=ts"

import "./RespMenu.vue?vue&type=style&index=0&id=299a813a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299a813a"]])

export default __exports__